import React, { useCallback, useMemo, useState } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import * as Yup from 'yup';
import {Link} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { yupResolver } from '@hookform/resolvers/yup';
import axiosInstance, { API_ENDPOINTS } from '../axios/axiosInstance';
import { enqueueSnackbar } from 'notistack';
import FormProvider from './hook-form/form-provider';
import { RHFCheckbox, RHFTextField } from './hook-form';
import SEO from './SEO';
import Turnstile from './Turnstile';
const Contacto = ({current}) => {
  const { t, i18n } = useTranslation();
  const [turnstileToken, setTurnstileToken] = useState(null);

  const reservationSchema = Yup.object().shape({
    fullName: Yup.string().required(t('reservations.requiredField')),
    email: Yup.string().required(t('reservations.requiredField')),
    message: Yup.string().required(t('reservations.requiredField')),
    terms: Yup.bool().oneOf([true], t('reservations.requiredField'))
  });
  const defaultValues = useMemo(
    () => ({
      fullName: current?.fullName || '',
      email: current?.email || '',
      message: current?.message || '',
      terms: current?.terms || false
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [current]
  );
  const methods = useForm({
    resolver: yupResolver(reservationSchema),
    defaultValues,
  });
  
  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  
  const onSubmit = useCallback(
    async (data) => {
      try {
        if (!turnstileToken) {
          enqueueSnackbar('Por favor, complete a verificação de segurança.', { variant: 'error' });
          return;
        }

        const dataWithToken = { ...data, turnstileToken, language: i18n.language };
        await axiosInstance.post(API_ENDPOINTS.contact, dataWithToken);
        enqueueSnackbar(t('contacts.successMessage'));
        reset();
        setTurnstileToken(null);
      } catch (error) {
        console.error(error);
      }
    },
    [reset, t, turnstileToken, i18n.language]
  );
  
  return ( <>
    <SEO
      titleKey="seo.contactsTitle"
      descriptionKey="seo.contactsDescription"
      path="/contacts"
    />
    <section className="banner ">
    <div id="menu-parallax">
      <div
        className="bcg background42 dark"
        data-center="background-position: 50% 0px;"
        data-anchor-target="#menu-parallax">
        <div className="bg-transparent" style={{
          zIndex: 99
        }}>
          <div className="banner-content">
            <div className="container">
              <div
                className="slider-content  "
                style={{
                paddingTop: '160.5px'
              }}>
                <h1>{t('contacts.title')}</h1>
                <p>{t('contacts.subtitle')}</p>
                <ol className="breadcrumb">
                  <li>
                    <Link to='/'>{t('nav.home')}</Link>
                  </li>
                  <li>{t('contacts.breadcrumb')}</li>
                </ol>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
 
  <section className="contact text-center padding-t-20">
      <div className="container">
        <div className="row">

            <div className="head_title" style={{marginBottom: '0px'}}>
            <img src="img/inicio/logo_hist.png" alt="Fleur de Sel Luxembourg - Contactos" className='w-10px'/>
                <h3>{t('contacts.mainTitle')}</h3>
                <span className="welcome">{t('contacts.mainSubtitle')}</span>
            </div>
        </div>
      </div>
    </section>
   
  <section className="padding-b-20">
  <Container component="main" maxWidth="md" sx={{ mb: 1 }}>
        <Paper sx={{ boxShadow: "none",my: { xs: 0, md: 0 }, p: { xs: 2, md: 3 } }}>
  <React.Fragment>
  <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Typography sx={{my:{xs:1,md:2}}} variant="h6" gutterBottom>
        {t('contacts.formTitle')}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <RHFTextField
            id="fullName"
            name="fullName"
            label={t('contacts.fullName')}
            fullWidth
            inputProps={{
                autoComplete: 'off'
             }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RHFTextField
            id="email"
            name="email"
            label={t('contacts.email')}
            fullWidth
            inputProps={{
                autoComplete: 'off'
             }}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <RHFTextField
            id="message"
            multiline
            name="message"
            label={t('contacts.message')}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Turnstile
            onVerify={(token) => setTurnstileToken(token)}
            onExpire={() => setTurnstileToken(null)}
          />
        </Grid>
        <Grid item xs={12} sm={9} className='primary-color'>
        <RHFCheckbox
            name="terms"
            label={
                <Typography style={{fontSize:'12px'}}>
       {t('contacts.terms')}{' '}
            <Link to="/terms-and-conditions" style={{fontWeight:'bold'}} className='active' target="_blank">
              {t('contacts.termsLink')}
            </Link>.
      </Typography>
      }
          />
        </Grid>
        <Grid item xs={12} sm={3} style={{textAlign:'right'}}>
        <LoadingButton loading={isSubmitting} disabled={!turnstileToken} type='submit' fullWidth variant="contained"  className='white-color' size="large">{t('contacts.submit')}</LoadingButton>
        </Grid>
      </Grid>
      </FormProvider>
    </React.Fragment></Paper></Container>
  </section>
  <section className="contact text-center padding-t-20 ">
      <div className="container">
        <div className="row">

            <div className="head_title" style={{marginBottom: '0px'}}>
                <span className="welcome">{t('contacts.alternativeContacts')}</span>
            </div>
        </div>
      </div>
    </section>
  <section className=" padding-t-60 text-center padding-b-40">
    <Container component="main" maxWidth="md" sx={{ mb: 1 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3}>
          <a href="https://www.facebook.com/profile.php?id=100063786393603" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Icon className='color-dark' icon="ic:baseline-facebook" width={'30%'} />
            <h4>{t('contacts.facebook')}</h4>
            <address>@Rodízio_fleurdesel</address>
          </a>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Icon className='color-dark' icon="ic:baseline-location-on" width={'30%'} />
          <h4>{t('contacts.address')}</h4>
          <address>25 rue Joseph Junck<br/>Luxembourg, Luxembourg</address>
        </Grid>
        <Grid item xs={12} sm={3}>
          <a href="mailto:reservations@fleurdeselrestaurant.lu" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Icon className='color-dark' icon="ic:baseline-email" width={'30%'} />
            <h4>{t('contacts.emailLabel')}</h4>
            <address>reservations@fleurdeselrestaurant.lu</address>
          </a>
        </Grid>
        <Grid item xs={12} sm={3}>
          <a href="tel:+352283719 79" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Icon className='color-dark' icon="ic:baseline-phone" width={'30%'} />
            <h4>{t('contacts.phone')}</h4>
            <address>(+352) 28 37 19 79</address>
          </a>
        </Grid>
      </Grid>
    </Container>
    </section>
   </>
  );
};

export default Contacto;